import subjectsDataRaw from "../../../../../data/subjects.json";

interface Subject {
    id?: number;
    category: string;
    subCategory: string;
    subCategory_eng?: string;
    subCategory_tch?: string;
    subject: string;
    subject_eng?: string;
    subject_tch?: string;
    abbreviation: string | string[];
    careers?: string[];
    careers_eng?: string[];
    careers_tch?: string[];
}

interface SubjectNameData {
    name_eng: string;
    name_tch?: string;
}

const subjectNameData = subjectsDataRaw as SubjectNameData[];

const subjectsRaw: Subject[] = [
    {
        category: "A",
        subCategory: "Core",
        subCategory_eng: "Core",
        subCategory_tch: "核心科目",
        subject: "Chinese Language",
        subject_eng: "Chinese Language",
        subject_tch: "中國語文",
        abbreviation: "chineseLanguage"
    },
    {
        category: "A",
        subCategory: "Core",
        subCategory_eng: "Core",
        subCategory_tch: "核心科目",
        subject: "English Language",
        subject_eng: "English Language",
        subject_tch: "英國語文",
        abbreviation: "englishLanguage"
    },
    {
        category: "A",
        subCategory: "Core",
        subCategory_eng: "Core",
        subCategory_tch: "核心科目",
        subject: "Mathematics",
        subject_eng: "Mathematics",
        subject_tch: "數學",
        abbreviation: "mathematics"
    },
    {
        category: "A",
        subCategory: "Core",
        subCategory_eng: "Core",
        subCategory_tch: "核心科目",
        subject: "Citizenship and Social Development",
        subject_eng: "Citizenship and Social Development",
        subject_tch: "公民與社會發展",
        abbreviation: "citizenshipAndSocialDevelopment"
    },
    {
        category: "A",
        subCategory: "Elective",
        subCategory_eng: "Elective",
        subCategory_tch: "選修科目",
        subject: "Mathematics Extended Part Module 1",
        subject_eng: "Mathematics Extended Part Module 1",
        subject_tch: "數學延伸部分 (M1)",
        abbreviation: "MATH-M1"
    },
    {
        category: "A",
        subCategory: "Elective",
        subCategory_eng: "Elective",
        subCategory_tch: "選修科目",
        subject: "Mathematics Extended Part Module 2",
        subject_eng: "Mathematics Extended Part Module 2",
        subject_tch: "數學延伸部分 (M2)",
        abbreviation: "MATH-M2"
    },
    {
        category: "C",
        subCategory: "Elective",
        subCategory_eng: "Elective",
        subCategory_tch: "選修科目",
        subject: "Chinese Literature",
        subject_eng: "Chinese Literature",
        subject_tch: "中國文學",
        abbreviation: "CHIN-LIT"
    },
    {
        category: "C",
        subCategory: "Elective",
        subCategory_eng: "Elective",
        subCategory_tch: "選修科目",
        subject: "English Literature",
        subject_eng: "English Literature",
        subject_tch: "英國文學",
        abbreviation: "ENG-LIT"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Biology",
        subject_eng: "Biology",
        subject_tch: "生物",
        abbreviation: "BIO"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Business, Accounting and Financial Studies",
        subject_eng: "Business, Accounting and Financial Studies",
        subject_tch: "企業、會計與財務概論",
        abbreviation: "BAFS"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Literature in English",
        subject_eng: "Literature in English",
        subject_tch: "英國文學",
        abbreviation: "LIT-ENG"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Chemistry",
        subject_eng: "Chemistry",
        subject_tch: "化學",
        abbreviation: "CHEM"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Design and Applied Technology",
        subject_eng: "Design and Applied Technology",
        subject_tch: "設計與應用科技",
        abbreviation: "DAT"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Chinese History",
        subject_eng: "Chinese History",
        subject_tch: "中國歷史",
        abbreviation: "CHIN-HIST"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Physics",
        subject_eng: "Physics",
        subject_tch: "物理",
        abbreviation: "PHY"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Health Management and Social Care",
        subject_eng: "Health Management and Social Care",
        subject_tch: "健康管理與社會關懷",
        abbreviation: "HMSC"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Economics",
        subject_eng: "Economics",
        subject_tch: "經濟",
        abbreviation: "ECO"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Information and Communication Technology",
        subject_eng: "Information and Communication Technology",
        subject_tch: "資訊及通訊科技",
        abbreviation: "ICT"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Ethics and Religious Studies",
        subject_eng: "Ethics and Religious Studies",
        subject_tch: "倫理與宗教",
        abbreviation: "ERS"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Technology and Living",
        subject_eng: "Technology and Living",
        subject_tch: "科技與生活",
        abbreviation: "T&L"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Geography",
        subject_eng: "Geography",
        subject_tch: "地理",
        abbreviation: "GEO"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Music",
        subject_eng: "Music",
        subject_tch: "音樂",
        abbreviation: "MUS"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "History",
        subject_eng: "History",
        subject_tch: "歷史",
        abbreviation: "HIST"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Visual Arts",
        subject_eng: "Visual Arts",
        subject_tch: "視覺藝術",
        abbreviation: "VA"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Tourism and Hospitality Studies",
        subject_eng: "Tourism and Hospitality Studies",
        subject_tch: "旅遊與款待",
        abbreviation: "THS"
    },
    {
        category: "A",
        subCategory: "Elective",
        subject: "Physical Education",
        subject_eng: "Physical Education",
        subject_tch: "體育",
        abbreviation: "PE"
    },
    {
        category: "A",
        subCategory: "Elective",
        subCategory_eng: "Elective",
        subCategory_tch: "選修科目",
        subject: "Combined Science (Physics, Chemistry)",
        subject_eng: "Combined Science (Physics, Chemistry)",
        subject_tch: "組合科學（物理、化學）",
        abbreviation: "CS-PHY-CHEM"
    },
    {
        category: "A",
        subCategory: "Elective",
        subCategory_eng: "Elective",
        subCategory_tch: "選修科目",
        subject: "Combined Science (Biology, Physics)",
        subject_eng: "Combined Science (Biology, Physics)",
        subject_tch: "組合科學（生物、物理）",
        abbreviation: "CS-BIO-PHY"
    },
    {
        category: "A",
        subCategory: "Elective",
        subCategory_eng: "Elective",
        subCategory_tch: "選修科目",
        subject: "Combined Science (Chemistry, Biology)",
        subject_eng: "Combined Science (Chemistry, Biology)",
        subject_tch: "組合科學（化學、生物）",
        abbreviation: "CS-CHEM-BIO"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Creative Studies",
        abbreviation: "CS"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Cultural and Creative Product Design",
        abbreviation: "CCPD"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Fashion Image Design",
        abbreviation: "FID"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Interior and Exhibition Design/Interior and Event Spatial Design",
        abbreviation: ["IED", "IESD"]
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Jewellery Design in Digital Age",
        abbreviation: "JDDA"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Computer Game and Animation Design",
        abbreviation: "CGAD"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Digital Comic Design and Production",
        abbreviation: "DCDP"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Popular Music Production",
        abbreviation: "PMP"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "Taking a Chance on Dance",
        abbreviation: "TCD"
    },
    {
        category: "B",
        subCategory: "Creative Studies",
        subject: "The Essentials of Theatre Arts",
        abbreviation: "ET"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Digital Media and Radio Production",
        abbreviation: "DMRP"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Film and Transmedia/Film Production",
        abbreviation: ["FT", "FP"]
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Digital Brand Communication/Digital Advertising",
        abbreviation: ["DBC", "DA"]
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Multimedia Storytelling",
        abbreviation: "MS"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "PR and Multimedia Communication",
        abbreviation: "PRMC"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Applied Learning (Vocational English) - English Communication",
        abbreviation: "ALVE-EC"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Applied Learning (Vocational English) - English for Business Services",
        abbreviation: "ALVE-EBS"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Applied Learning (Vocational English) - English for Service Professionals",
        abbreviation: "ALVE-ESP"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Creative English - Cultural Tourism",
        abbreviation: "CE-CT"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Creative English - Biz and Media",
        abbreviation: "CE-BM"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Creative English - PR and Marketing",
        abbreviation: "CE-PRM"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Practical Translation (CHIN-ENG)",
        abbreviation: "PT"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Applied Japanese and Japanese Culture",
        abbreviation: "AJJC"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Everyday Japanese and Japanese Culture",
        abbreviation: "EJJC"
    },
    {
        category: "B",
        subCategory: "Media and Communication",
        subject: "Korean Language and Culture",
        abbreviation: "KLC"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "Accounting in Action",
        abbreviation: "AIA"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "Accounting for e-Business",
        abbreviation: "AEB"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "AI in Business",
        abbreviation: "AIB"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "Data Application for Business/AI Application in Business Data",
        abbreviation: ["DAB", "AIABD"]
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "Innovation and Entrepreneurship",
        abbreviation: "IE"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "Introduction to Fintech",
        abbreviation: "ITF"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "KOL Marketing and Generative AI",
        abbreviation: "KOL"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "Marketing and Online Promotion",
        abbreviation: "MOP"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "Modern Logistics Studies",
        abbreviation: "MLS-BML"
    },
    {
        category: "B",
        subCategory: "Business, Management and Law",
        subject: "Law Enforcement in Hong Kong",
        abbreviation: "LE-HK"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Modern Southeast Asian Cuisine",
        abbreviation: "MSAC"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "PÃ¢tisserie and CafÃ© Operations",
        abbreviation: "P&CO"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Western Cuisine",
        abbreviation: "WC"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Airport Passenger Terminal Operations/Airport Operations and Services",
        abbreviation: ["APTO", "AOS"]
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Hospitality Services in Practice",
        abbreviation: "HSP"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Hotel Operations",
        abbreviation: "HO"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Child Care and Development",
        abbreviation: "CCD"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Child Care and Education",
        abbreviation: "CCE"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Fundamental Cosmetology",
        abbreviation: "FC"
    },
    {
        category: "B",
        subCategory: "Services",
        subject: "Gerontech and Services",
        abbreviation: "G&S"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Food Technology and Nutrition",
        abbreviation: "FTN"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Foundation in Chinese Medicine",
        abbreviation: "FCM"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Health Care Practice",
        abbreviation: "HCP"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Medical Laboratory Science",
        abbreviation: "MLS-AS"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Pet Care and Grooming",
        abbreviation: "PCG"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Rehabilitation Care Practice",
        abbreviation: "RCP"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Applied Psychology",
        abbreviation: "AP"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Practical Psychology",
        abbreviation: "PP"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Exercise and Fitness Coaching",
        abbreviation: "EFC"
    },
    {
        category: "B",
        subCategory: "Applied Science",
        subject: "Exercise Science and Health Fitness",
        abbreviation: "ESH"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "Digital Construction",
        abbreviation: "DC"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "Electrical and Energy Engineering",
        abbreviation: "EEE"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "AI and Robotics",
        abbreviation: "AIR"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "Computer Forensic Technology",
        abbreviation: "CFT"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "Cybersecurity",
        abbreviation: "CYB"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "eSports Technology and Management",
        abbreviation: "ETM"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "Tech Basics",
        abbreviation: "TB"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "Aviation Studies",
        abbreviation: "AS"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "Railway Studies",
        abbreviation: "RS"
    },
    {
        category: "B",
        subCategory: "Engineering and Production",
        subject: "UAV and Low-altitude Economy",
        abbreviation: "ULAE"
    },
    {
        category: "B",
        subCategory: "Applied Learning Chinese",
        subject: "Chinese in Business Service",
        abbreviation: "CIBS"
    },
    {
        category: "B",
        subCategory: "Applied Learning Chinese",
        subject: "Chinese in Practical Context",
        abbreviation: "CIPC"
    },
    {
        category: "B",
        subCategory: "Applied Learning Chinese",
        subject: "Communicative Chinese",
        abbreviation: "CC"
    },
    {
        category: "B",
        subCategory: "Applied Learning Chinese",
        subject: "Practical Chinese",
        abbreviation: "PC"
    },
    {
        category: "C",
        subCategory: "Other Languages",
        subject: "French",
        abbreviation: "FRENCH"
    },
    {
        category: "C",
        subCategory: "Other Languages",
        subject: "German",
        abbreviation: "GERMAN"
    },
    {
        category: "C",
        subCategory: "Other Languages",
        subject: "Japanese",
        abbreviation: "JAPANESE"
    },
    {
        category: "C",
        subCategory: "Other Languages",
        subject: "Korean",
        abbreviation: "KOREAN"
    },
    {
        category: "C",
        subCategory: "Other Languages",
        subject: "Spanish",
        abbreviation: "SPANISH"
    },
    {
        category: "C",
        subCategory: "Other Languages",
        subject: "Urdu",
        abbreviation: "URDU"
    }
];

export const subjectCodes = subjectsRaw.map(subject => subject.abbreviation).flat();

// Function to check for duplicate abbreviations
const checkDuplicates = (subjects: Subject[]) => {
    const abbreviationSet = new Set();
    const duplicates = new Set();

    subjects.forEach(subject => {
        const abbreviations = Array.isArray(subject.abbreviation) ? subject.abbreviation : [subject.abbreviation];

        abbreviations.forEach(abbr => {
            if (abbreviationSet.has(abbr)) {
                duplicates.add(abbr);
            } else {
                abbreviationSet.add(abbr);
            }
        });
    });

    return [...duplicates];
};

export const duplicateAbbreviations = checkDuplicates(subjectsRaw);

export const subjects = subjectsRaw.map((subject, index) => ({
    id: index + 1,
    ...subject
}));

export const filteredSubjects = (category?: string, subCategory?: string) => {
    return subjects.filter(
        (subject) =>
            category && subCategory ? subject.category === category && subject.subCategory === subCategory
                : category && !subCategory ? subject.category === category
                    : !category && subCategory ? subject.subCategory === subCategory
                        : true
    );
}

export const getSubjectByAbbreviation = (abbreviation: string) => {
    return subjects.find(subject => {
        if (Array.isArray(subject.abbreviation)) {
            return subject.abbreviation.includes(abbreviation);
        }
        return subject.abbreviation === abbreviation;
    });
}

export const getSubjectByName = (name: string) => {
    return subjects.find(subject => subject.subject.split("/").includes(name));
}

export const getSubjectDisplayName = (subjectName: string, language: string): string => {
    const subject = subjectsRaw.find(s => s.subject === subjectName);
    const subjectNameEntry = subjectNameData.find(s => s.name_eng === subjectName);

    if (language === 'zh') {
        return subject?.subject_tch || subjectNameEntry?.name_tch || subject?.subject || subjectName;
    }

    return subject?.subject_eng || subjectNameEntry?.name_eng || subject?.subject || subjectName;
};
